import { agingMarginEnable, getMarginRequirement, isComboPON } from "../../tools";

export const BudgetMethods = (id: string) => {
    const methods: { [key: string]: any } = {
        "aging_margin_res": {
            isVisible: () => {
                return agingMarginEnable();
            }
        },
        "aging_img": {
            isVisible: () => {
                return agingMarginEnable();
            }
        },
        "budget_result_xgspon": {
            prepareData: (component: any, allState: any) => {
                if (!Number.isNaN(+component.val)) {
                    const XGS_RS_SENS = isComboPON() ? allState.xgs_pon_rx_comb_trans_sens.gain_loss : allState.xgs_pon_rx_xgs_trans_sens.gain_loss
                    const redRule = +component.val < XGS_RS_SENS;
                    const orangeRule = +component.val > XGS_RS_SENS && (+component.val - getMarginRequirement(allState)) < XGS_RS_SENS;
                    const greenRule = (+component.val - getMarginRequirement(allState)) > XGS_RS_SENS;
                    if (redRule) {
                        component.color = 'red'
                    } else if (orangeRule) {
                        component.color = 'orange'
                    } else if (greenRule) {
                        component.color = 'green'
                    }
                }
                return component;
            }
        },
        "budget_result_gpon": {
            prepareData: (component: any, allState: any) => {
                if (!Number.isNaN(+component.val)) {
                    const GPON_RS_SENS = isComboPON() ? allState.gpon_rx_comb_trans_sens.gain_loss : allState.gpon_rx_gpon_sens.gain_loss
                    const redRule = +component.val < GPON_RS_SENS;
                    const orangeRule = +component.val > GPON_RS_SENS && (+component.val - getMarginRequirement(allState)) < GPON_RS_SENS;
                    const greenRule = (+component.val - getMarginRequirement(allState)) > GPON_RS_SENS;
                    if (redRule) {
                        component.color = 'red'
                    } else if (orangeRule) {
                        component.color = 'orange'
                    } else if (greenRule) {
                        component.color = 'green'
                    }
                }
                return component;
            }
        }
    }
    return methods[id]
}